import { makeStyles } from '@material-ui/core/styles';
import { Theme } from '@material-ui/core';

export const useStyles = makeStyles((theme: Theme) => ({
  card: {
    marginBottom: 10,
    borderRadius: 20,
    border: '1px solid rgba(0, 0, 0, 0.2)', // Borde oscuro
    boxShadow: '0px 2px 5px rgba(0, 0, 0, 0.1)',
    // Aquí puedes establecer un tamaño específico, como el ancho y alto que mencionaste
    width: '400px', // Ajusta según lo necesario
    height: '350px', // Ajusta según lo necesario
    display: 'flex',
    flexDirection: 'column',
  },
  dialogTitle: {
    background: '#02CBF5',
    padding: theme.spacing(2), // Para dar un poco de espacio
    color: 'white',
  },
  divider: {
    backgroundColor: 'rgba(0, 0, 0, 0.2)', // Borde más oscuro para el Divider
    margin: '10px 0',
  },
  verticalDivider: {
    backgroundColor: 'rgba(0, 0, 0, 0.2)', // Divider vertical oscuro
    height: '100%',
    margin: '0 10px',
  },
  cardHeader: {
    backgroundColor: '#02CBF5',
    color: '#fff',
    textAlign: 'center',
  },
  logo: {
    height: '20px',
    marginRight: '20px',
  },
  premiumChip: {
    minWidth: '160px',
    background: '#02CBF4',
    color: '#fff',
    fontWeight: 'bold',
  },
  estandarChip: {
    minWidth: '160px',
    background: '#2196f3',
    color: '#fff',
    fontWeight: 'bold',
  },
  basicChip: {
    minWidth: '160px',
    background: '#9e9e9e',
    color: '#fff',
    fontWeight: 'bold',
  },
  noClassChip: {
    minWidth: '160px',
    background: '#ffff',
    color: '#000',
    fontWeight: 'bold',
  },
  chipContainer: {
    textAlign: 'center',
    marginTop: '2px',
  },
}));
